import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetRouteTemplatesQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetRouteTemplatesQuery = { __typename?: 'query_root', route_templates: Array<{ __typename?: 'route_templates', id: number, name: string, stops: object, created_at: string, updated_at: string, runs_aggregate: { __typename?: 'mobility_runs_aggregate', aggregate?: { __typename?: 'mobility_runs_aggregate_fields', count: number } | null } }> };


export const GetRouteTemplatesDocument = gql`
    query getRouteTemplates($customerId: bigint!) {
  route_templates(
    where: {customer_id: {_eq: $customerId}, product_type: {_eq: "parts_delivery"}}
    order_by: {name: asc}
  ) {
    id
    name
    stops
    created_at
    updated_at
    runs_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetRouteTemplatesQuery__
 *
 * To run a query within a React component, call `useGetRouteTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRouteTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRouteTemplatesQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetRouteTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetRouteTemplatesQuery, GetRouteTemplatesQueryVariables> & ({ variables: GetRouteTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRouteTemplatesQuery, GetRouteTemplatesQueryVariables>(GetRouteTemplatesDocument, options);
      }
export function useGetRouteTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRouteTemplatesQuery, GetRouteTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRouteTemplatesQuery, GetRouteTemplatesQueryVariables>(GetRouteTemplatesDocument, options);
        }
// @ts-ignore
export function useGetRouteTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRouteTemplatesQuery, GetRouteTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRouteTemplatesQuery, GetRouteTemplatesQueryVariables>;
export function useGetRouteTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRouteTemplatesQuery, GetRouteTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRouteTemplatesQuery | undefined, GetRouteTemplatesQueryVariables>;
export function useGetRouteTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRouteTemplatesQuery, GetRouteTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRouteTemplatesQuery, GetRouteTemplatesQueryVariables>(GetRouteTemplatesDocument, options);
        }
export type GetRouteTemplatesQueryHookResult = ReturnType<typeof useGetRouteTemplatesQuery>;
export type GetRouteTemplatesLazyQueryHookResult = ReturnType<typeof useGetRouteTemplatesLazyQuery>;
export type GetRouteTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetRouteTemplatesSuspenseQuery>;
export type GetRouteTemplatesQueryResult = Apollo.QueryResult<GetRouteTemplatesQuery, GetRouteTemplatesQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/getRouteTemplates.query.gql}
 */
export async function getRouteTemplates(
  variables: GetRouteTemplatesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetRouteTemplatesQuery['route_templates']>
export async function getRouteTemplates(
  variables: GetRouteTemplatesQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetRouteTemplatesQuery>
export async function getRouteTemplates(
  variables: GetRouteTemplatesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetRouteTemplatesQuery['route_templates'] | GetRouteTemplatesQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetRouteTemplatesQuery>(
    GetRouteTemplatesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.route_templates
}